// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import DiagnosisPrescriptions from "../../components/diagnosisPrescriptions";

const DiagnosisPrescriptionsView = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <DiagnosisPrescriptions />
    </Main>
  </>
);

export default DiagnosisPrescriptionsView;
